import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import FunctionalTestTarget, {
  FUNCTIONAL_TEST_IDS,
} from 'components/FunctionalTestTarget';
import './PdpNotice.css';
import cx from 'classnames';
import {connect} from 'react-redux';
import {
  selectIsEmbed,
  selectIsPublic,
} from 'state/environment/environmentSelectors';
import {loadDataSourcesByCardId} from 'state/dataSource/dataSourceActions';
import {selectHasFilterGroups} from 'state/dataSource/dataSourceSelectors';

class PdpNotice extends React.Component {
  constructor() {
    super(...arguments);
    this.handleMessageClick = this.handleMessageClick.bind(this);
    this.state = {expanded: false};
  }

  componentDidMount() {
    const {cardId, isEmbed, isPublic} = this.props;
    if (!isEmbed && !isPublic && cardId) {
      this.props.loadDataSourcesByCardId(cardId);
    }
  }

  handleMessageClick(e) {
    e.stopPropagation();
    this.setState({expanded: !this.state.expanded});
  }

  render() {
    const {chartRender, isEmbed, hasFilterGroups} = this.props;
    const isChartRenderPdp = chartRender && chartRender.pdpEnabled;
    const isPdpEnabled = hasFilterGroups || isChartRenderPdp;

    if (isEmbed || !isPdpEnabled) return null;

    return (
      <FunctionalTestTarget id={FUNCTIONAL_TEST_IDS.OBJECTS__PDP_NOTICE_BUTTON}>
        <div className="PdpNotice">
          <div
            onClick={this.handleMessageClick}
            className={cx({
              PdpNotice__Message: true,
              'PdpNotice__Message--expanded': this.state.expanded,
            })}
          >
            {this.state.expanded ? (
              <FormattedMessage
                id="PdpNotice__Message"
                description="Notice indcating that Personalized Data Permissions are enabled for this chart"
                defaultMessage="Personalized Data Permissions enabled"
              />
            ) : (
              'PDP'
            )}
          </div>
        </div>
      </FunctionalTestTarget>
    );
  }
}

PdpNotice.propTypes = {
  chartRender: PropTypes.object,
};

export default connect(
  (state, {cardId}) => ({
    isEmbed: selectIsEmbed(state),
    isPublic: selectIsPublic(state),
    hasFilterGroups: selectHasFilterGroups(state, cardId),
  }),
  {
    loadDataSourcesByCardId,
  }
)(PdpNotice);
